/* Nav V9 — desktop hover dropdowns, mobile expand/collapse, Clarity events. */
(function () {
  if (window.__nv9) return;
  window.__nv9 = true;

  function track(name, value) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        if (value) window.clarity('set', name, String(value).slice(0, 60));
      }
    } catch (e) {}
  }

  // Mobile: category rows expand/collapse (one open at a time). The drawer is inserted
  // lazily by the theme, so listen at the document level.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nv9-toggle]');
    if (btn) {
      var root = btn.closest('[data-nv9-mobile]');
      var opening = btn.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('[data-nv9-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.querySelector('.nv9-plus').textContent = '+';
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });
      if (opening) {
        btn.setAttribute('aria-expanded', 'true');
        btn.querySelector('.nv9-plus').textContent = '−';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
        track('nav_v9_mobile_expand', btn.getAttribute('data-nv9-cat'));
      }
      return;
    }
    var link = e.target.closest('[data-nv9-mobile] a, [data-nv9-desk] a');
    if (link) {
      var mobile = !!link.closest('[data-nv9-mobile]');
      track(mobile ? 'nav_v9_mobile_click' : 'nav_v9_desktop_click', link.textContent.replace(/\s+/g, ' ').trim());
    }
  });

  // Mobile: drawer opened (the theme toggles .menu-opening on #mobile-navigation).
  // The drawer element only exists after the first interaction, so wait for it, then watch just it.
  var drawerOpen = false;
  function watchDrawer(d) {
    new MutationObserver(function () {
      var open = d.classList.contains('menu-opening');
      if (open && !drawerOpen) track('nav_v9_mobile_open');
      drawerOpen = open;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }
  var existing = document.querySelector('#mobile-navigation.menu-drawer');
  if (existing) {
    watchDrawer(existing);
  } else {
    var waiter = new MutationObserver(function () {
      var d = document.querySelector('#mobile-navigation.menu-drawer');
      if (d) { waiter.disconnect(); watchDrawer(d); }
    });
    waiter.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  // Desktop: open on hover / keyboard focus, close with a short delay so the pointer
  // can travel from the label into the dropdown.
  function initDesktop() {
    var items = document.querySelectorAll('[data-nv9-desk] .nv9-desk__item');
    items.forEach(function (li) {
      var timer;
      function open() {
        clearTimeout(timer);
        items.forEach(function (o) { if (o !== li) o.classList.remove('is-open'); });
        if (li.classList.contains('has-panel') && !li.classList.contains('is-open')) {
          li.classList.add('is-open');
          track('nav_v9_desktop_open', li.getAttribute('data-nv9-cat'));
        }
      }
      function close() { timer = setTimeout(function () { li.classList.remove('is-open'); }, 150); }
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', close);
      li.addEventListener('focusin', open);
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) li.classList.remove('is-open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') items.forEach(function (o) { o.classList.remove('is-open'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDesktop);
  else initDesktop();
})();
